import React, { Component } from 'react';
import { useTheme } from '@mui/material/styles';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import AlertTitle from '@mui/material/AlertTitle';
import { ResponsiveContainer } from 'recharts';
import Grid from '@mui/material/Grid';

function generateRandomInteger(min, max) {
    return Math.round(
        (Math.random() * (max - min) + min) * 100,
    ) / 100
}


class AlertsList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            percent: this.props.min,
            min: this.props.min,
            max: this.props.max,
            measurement: `${'\u00b0'}C`,
            status: 'warning',
            message: 'Warning',
            desc: 'Core Transformer Oil Temp is higher.'
        }
    }


    componentDidMount() {
        
        this.interval = setInterval(
            () =>
                this.setState({
                    status: ((this.state.status == 'error') ? 'warning' : 'error'),
                    message: ((this.state.status == 'error') ? 'Warning' : 'Error'),
                    desc: ((this.state.status == 'error') ? 'Transformer Winding Temp is high!' : 'Transformer Winding Temp is rising')
                })
            , 1000
        )
    };

    componentWillUnmount() {
        clearInterval(this.interval);

    }

    render() {
        return (
            <div>
                <Grid spacing={0}>
                    <Grid item xs={12}>
                        <h2>{this.props.name}</h2>
                    </Grid>
                    <Grid item xs={12}>
                        <ResponsiveContainer>

                            <Stack sx={{ width: '100%' }} spacing={2}>
                                <Alert variant="filled" severity="warning">
                                <AlertTitle>Warning</AlertTitle>
                                    Transformer Winding Temp is rising
                                </Alert>
                                <Alert variant="filled" severity={this.state.status}>
                                <AlertTitle>{this.state.message}</AlertTitle>
                                    {this.state.desc}
                                </Alert>
                                <Alert variant="filled" severity="info">
                                <AlertTitle>Info</AlertTitle>
                                    Breaker Maintenance scheduled!
                                </Alert>
                                <Alert variant="filled" severity="success">
                                <AlertTitle>Success</AlertTitle>
                                    All other operation is normal.
                                </Alert>
                            </Stack>
                            
                        </ResponsiveContainer>
                        
                    </Grid>
                    <Grid item xs={12}>
                        {/* <div id="sensorInformationSection"></div> */}
                    </Grid>
                   
                </Grid>
            </div>
        );
    }
}

export default AlertsList;